import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'

// Values are the display labels themselves — the backend (corporate-node
// resolveAssessmentStatusFilter) matches the selected labels directly.
const AssessmentStatusFilter = ({ filterValues, handleFilterChange }) => {
  const statusOptions = [
    { label: 'Invite Pending', value: 'Invite Pending' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Dropped Off', value: 'Dropped Off' },
    { label: 'Completed', value: 'Completed' },
  ]

  const selectedValues = (filterValues?.selectedAssessmentStatus || []).map(item =>
    typeof item === 'object' ? item.value : item
  )

  return (
    <FilterCheckBoxComp
      options={statusOptions}
      value={selectedValues}
      onChange={handleFilterChange}
      valueParam="value"
      labelParam="label"
      valueKey="selectedAssessmentStatus"
    />
  )
}

export default AssessmentStatusFilter
